import { sqliteTable, text, real, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// wht_types — ประเภทเงินได้สำหรับภาษีหัก ณ ที่จ่าย
// เช่น ค่าบริการ 3%, ค่าขนส่ง 1%, ค่าจ้างทำของ 5%
// ============================================================================
export const whtTypes = sqliteTable("accounting_wht_types", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  code: text("code").notNull(), // e.g. "WHT-3-SERVICE"
  name: text("name").notNull(), // e.g. "ค่าบริการ / ค่าเช่า"
  nameEn: text("name_en"), // e.g. "Service / Rent"
  incomeType: text("income_type").notNull(), // ประเภทเงินได้ ม.40(8), ม.40(2) etc.
  rate: real("rate").notNull(), // เช่น 3, 5, 1
  whtAccountId: text("wht_account_id"), // FK → accounts (บัญชีภาษีหัก ณ ที่จ่าย)
  isActive: integer("is_active").notNull().default(1),
  // System-seeded rows (from seedAccountingData) get is_system=1 so the UI can
  // render the "ระบบ" badge and the DELETE handler can block removal with 409.
  // Default 0 — user-created rows are deletable. See issue #344.
  isSystem: integer("is_system").notNull().default(0),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type WhtType = typeof whtTypes.$inferSelect;
export type NewWhtType = typeof whtTypes.$inferInsert;
